import * as _4 from 'lodash4';

export class APSectionTypeServant {
  static writeMultiSectionTypeLabel(sectionTypeName: string, labelColor: string): string {
    return `<span class='section-type-badge display-inline-block text-uppercase bdr-round-e mbs bas bdr-solid clr-gray_100-txt text-sz-s plsx prsx mrsxx ${labelColor}' title='${sectionTypeName}'>${_4.truncate(
      sectionTypeName,
      { length: 20 }
    )}</span>`;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/servants/ap_section_type_servant.ts